import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';
import Tooltip from 'flarum/common/components/Tooltip';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

export default class UploadButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.attrs.uploader.on('uploaded', () => {
      // reset the button for a new upload
      this.$('form')[0].reset();

      // redraw to reflect uploader.loading in the DOM
      m.redraw();
    });

    this.isMediaUploadButton = vnode.attrs.isMediaUploadButton || false;
  }

  view() {
    const buttonText = this.attrs.uploader.uploading
      ? app.translator.trans('fof-upload.forum.states.loading')
      : app.translator.trans('fof-upload.forum.buttons.upload');

    return (
      <Tooltip text={buttonText}>
        <Button
          className={classList([
            'Button',
            'hasIcon',
            'fof-upload-button',
            !this.isMediaUploadButton && !this.attrs.uploader.uploading && 'Button--icon',
            !this.isMediaUploadButton && !this.attrs.uploader.uploading && 'Button--link',
            this.attrs.uploader.uploading && 'uploading',
          ])}
          icon={!this.attrs.uploader.uploading && 'fas fa-file-upload'}
          onclick={this.uploadButtonClicked.bind(this)}
          disabled={this.attrs.disabled}
        >
          {this.attrs.uploader.uploading && <LoadingIndicator size="small" display="inline" className="Button-icon" />}
          {(this.isMediaUploadButton || this.attrs.uploader.uploading) && <span className="Button-label">{buttonText}</span>}
          <form>
            <input type="file" multiple={false} onchange={this.process.bind(this)} />
          </form>
        </Button>
      </Tooltip>
    );
  }

  /**
   * Process the upload event.
   *
   * @param e
   */
  process(e) {
    // get the file from the input field
    const files = this.$('input').prop('files');

    if (files.length === 0) {
      // We've got no files to upload, so trying
      // to begin an upload will show an error
      // to the user.
      return;
    }
    // 检查每个文件的类型
    // for (let i = 0; i < files.length; i++) {
    //   const file = files[i];
    //   if (!file.type.startsWith('image/')) {
    //     AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.warn.only_image'));
    //     e.target.value = null;
    //     return;
    //   }
    // }
    // 允许的MP3 MIME类型列表
    const allowedMP3Types = [
      'audio/mpeg', // 标准MP3类型
      'audio/mp3', // 部分浏览器使用
      'audio/x-mpeg',
      'audio/x-mp3',
      'audio/x-mpeg-3',
    ];

    for (const file of files) {
      // 检查是否是音频且非允许的MP3类型
      if (file.type.startsWith('audio/') && !allowedMP3Types.includes(file.type)) {
        AlertUtil.onWarn(app, '只能上传mp3格式的音频');
        e.target.value = null;
        return;
      }
    }
    this.attrs.uploader.upload(files, !this.isMediaUploadButton);
    e.target.value = null;
  }

  /**
   * Event handler for upload button being clicked
   *
   * @param {PointerEvent} e
   */
  uploadButtonClicked(e) {
    // Trigger click on hidden input element
    // (Opens file dialog)
    this.$('input').click();
  }
}
